// extracted by mini-css-extract-plugin
var _1 = "WdaIXsIUhOl8jl78BAnY";
var _2 = "QGTls7TnCEtzxqTfCLXX";
export { _1 as "ellipsis", _2 as "textWrapper" }
